import Vue from 'vue'
import VueRouter from "vue-router";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'layout',
        component: () => import('../layout/Index'),
        redirect: "/index",
        children: [
            {
                path: 'index',
                name: 'Index',
                component: () => import('../views/index/Index'),
                meta: {
                    title: '诗董中国'
                },
            },
            {
                path: 'group-introduction',
                name: 'group-introduction',
                component: () => import('../views/groupintroduction/Index'),
                meta: {
                    title: '集团介绍'
                },
            },
            {
                path: 'history',
                name: 'history',
                component: () => import('../views/history/Index'),
                meta: {
                    title: '集团介绍'
                },
            },
            {
                path: 'history',
                name: 'history',
                component: () => import('../views/history/Index'),
                meta: {
                    title: '发展历程'
                },
            },
            {
                path: 'awards',
                name: 'awards',
                component: () => import('../views/awards/Index'),
                meta: {
                    title: '荣誉奖项'
                },
            },
            {
                path: 'about',
                name: 'about',
                component: () => import('../views/about/Index'),
                meta: {
                    title: '诗董中国'
                },
            },
            {
                path: 'business-introduction',
                name: 'business-introduction',
                component: () => import('../views/businessintroduction/Index'),
                meta: {
                    title: '业务介绍'
                },
            },
            {
                path: 'rubber-products',
                name: 'rubber-products',
                component: () => import('../views/rubberproducts/Index'),
                meta: {
                    title: '橡胶产品'
                },
            },
            {
                path: 'product/introduction',
                name: 'product-introduction',
                component: () => import('../views/productintroduction/Index'),
                meta: {
                    title: '业务概况'
                },
            },
            {
                path: 'glove/category',
                name: 'glove-category',
                component: () => import('../views/glovecategory/Index'),
                meta: {
                    title: '手套分类'
                },
            },
            {
                path: 'shiruikang',
                name: 'shiruikang',
                component: () => import('../views/shiruikang/Index'),
                meta: {
                    title: '品牌系列'
                },
            },
            {
                path: 'news/company',
                name: 'news-company',
                component: () => import('../views/newscompany/Index'),
                meta: {
                    title: '公司新闻'
                },
            },
            {
                path: 'news/product',
                name: 'news-product',
                component: () => import('../views/newsproduct/Index'),
                meta: {
                    title: '橡胶资讯'
                },
            },
            {
                path: 'news/rubber',
                name: 'news-rubber',
                component: () => import('../views/newsrubber/Index'),
                meta: {
                    title: '手套资讯'
                },
            },
            {
                path: 'contact-us',
                name: 'contact-us',
                component: () => import('../views/contactus/Index'),
                meta: {
                    title: '联系我们'
                },
            },
            {
                path: 'news-detail',
                name: 'news-detail',
                component: () => import('../views/newsdetail/Index'),
                meta: {
                    title: '新闻详细'
                },
            },
            {
                path: 'product-detail',
                name: 'product-detail',
                component: () => import('../views/productdetail/Index'),
                meta: {
                    title: '产品信息'
                },
            }
        ],
    }
]


const router = new VueRouter({
    //mode: 'history',
    //base: process.env.BASE_URL,
    routes
})

export default router;
